import React, { useEffect, useState } from "react";
import ModalComponent from "@/components/modal";
import { DAYS } from "@/helpers";
import { Checkbox, Flex } from "antd";
import "@/styles/form/cloneSlot.scss";
import ButtonComponent from "@/components/button/Button";
import { updateUserAvailability } from "@/services/users/updateUserAvailability";
import { useDispatch } from "react-redux";
import { setModalOpen } from "@/reducers/commonSlice";
import {
  convertTimeRangesToUTC,
  getSlotDifferences,
  mergeTimeSlots,
  transformTimeSlots,
} from "@/services/luxon";

const CloneSlot = ({ isOpen, currentDay, currentSlot, savedLocalSlotData, fetchData }) => {
  const [selectedDays, setSelectedDays] = useState([]);
  const dispatch = useDispatch();

  const handleOnChange = (event) => {
    const value = event.target.value;
    if (event.target.checked) {
      setSelectedDays((prev) => [...prev, value]);
    } else {
      setSelectedDays(selectedDays.filter((x) => x !== value));
    }
  };

  const onUpdateAvailability = async (ranges, daysToUpdate) => {
    const deleteTimeSlots = [];
    const newAddTimeSlots = [];

    daysToUpdate.forEach((day) => {
      if (day) console.log("previous timeslots in Local:", savedLocalSlotData);
      const { deletedSlots, newSlots } = getSlotDifferences(ranges, savedLocalSlotData[day]);
      const deletePayloads = transformTimeSlots(convertTimeRangesToUTC(day, deletedSlots));
      console.log(`Delete Payloads for ${day}:`, deletePayloads);
      const newAddPayloads = transformTimeSlots(convertTimeRangesToUTC(day, newSlots));
      console.log(`New Add Payloads for ${day}:`, newAddPayloads);
      deleteTimeSlots.push(...deletePayloads);
      newAddTimeSlots.push(...newAddPayloads);
    });

    const mergedDeleteSlots = mergeTimeSlots(deleteTimeSlots);
    const mergedNewAddSlots = mergeTimeSlots(newAddTimeSlots);
    try {
      await Promise.all(
        mergedNewAddSlots.map((payload) =>
          updateUserAvailability({
            ...payload,
            action: "add",
          })
        )
      );
      await Promise.all(
        mergedDeleteSlots.map((payload) =>
          updateUserAvailability({
            ...payload,
            action: "remove",
          })
        )
      );
      console.log("All requests completed successfully.");
      fetchData();
    } catch (err) {
      console.error("Error in API calls:", err);
    }
  };

  const handleSave = async () => {
    console.log("Selected Days:", selectedDays);
    console.log("Current Day:", currentDay);
    console.log("Current Slot:", currentSlot);
    console.log("Saved Local Slot Data:", savedLocalSlotData);

    const days = [currentDay, ...selectedDays];
    await onUpdateAvailability(currentSlot, days);
    dispatch(setModalOpen(false));
    setSelectedDays([]);
  };

  useEffect(() => {
    // reset the selected days when modal is closed
    if (!isOpen) {
      setSelectedDays([]);
    }
  }, [isOpen]);

  return (
    <ModalComponent isOpen={isOpen} width={400} closeIcon className="clone-slot-wrapper">
      <div className="body-b1">Copy Session to</div>
      <Flex vertical gap={"0.8rem"} className="days-wrapper">
        {DAYS.map((d) => {
          return (
            <Flex className="clone-day-wrapper" justify="space-between" key={d.value}>
              <span className={`${selectedDays.includes(d.value) ? "active" : ""}`}>{d.label}</span>
              <Checkbox
                checked={selectedDays.includes(d.value)}
                onChange={handleOnChange}
                value={d.value}
                disabled={currentDay === d.value}
              />
            </Flex>
          );
        })}
      </Flex>
      <div>
        <ButtonComponent
          label="Apply"
          className="w-100"
          varient="primary"
          size="medium"
          onClick={handleSave}
        />
      </div>
    </ModalComponent>
  );
};

export default CloneSlot;
